/**
 * Calltoaction section
 */
(function($, window) {
	$(document).ready(function() {
		if ($('body').hasClass('not-logged-in')) {
			
//			/* TODO: Video modal? */
//			var $videoOverlay = $('<div class="sectionCalltoaction video-overlay"></div>'),
//				$video = $('<div class="sectionCalltoaction video-modal"></div>')
//				$main = $('#main'),
//				$youtube = $('.sectionCalltoaction .sectionYoutube');
//			
//			$youtube.each(function(i, elm) {
//				$elm = $(elm);
//				var $videoHTML = $('.videoembed', $elm).html(),
//					$iconOverlay = $('<div class="icon-overlay"></div>');
//				
//				$iconOverlay.on('click', function() {
//					$videoOverlay.show();
//					$video.html($videoHTML);
//					$video.show();
//				});
//				
//				$iconOverlay.appendTo($elm);
//			});
//			
//			$videoOverlay.on('click', function() {
//				$videoOverlay.hide();
//				$video.hide();
//				$video.empty();
//			});
//			
//			$video.appendTo($main);
//			$videoOverlay.appendTo($main);
		}
		
	});
	
})(jQuery, window);